/**
 * Convert between formats, such as Markdown to HTML or HTML to Markdown.
 */

import TurndownService from 'turndown'
import { tables } from 'turndown-plugin-gfm'
import showdown from 'showdown'

function superscript(service) {
  service.addRule('superscript', {
    filter: ['sup'],
    replacement: function (content) {
      return '^(' + content + ')'
    }
  })
}

function spoiler(service) {
  service.addRule('spoiler', {
    filter: ['mark'],
    replacement: function (content) {
      return '>!' + content + '!<'
    }
  })
}

function strikethrough(service) {
  service.addRule('strikethrough', {
    filter: ['del', 's', 'strike'],
    replacement: function (content) {
      return '~~' + content + '~~'
    }
  })
}

const turndownService = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
  hr: '---'
})

turndownService.use([tables, strikethrough, superscript, spoiler])

export function htmlToMarkdown(html) {
  return turndownService.turndown(html)
}

const showdownConverter = new showdown.Converter({
  tables: true,
  literalMidWordUnderscores: true,
  strikethrough: true,
  ghCodeBlocks: true,
  disableForced4SpacesIndentedSublists: true
})

// Lovingly borrowed from this GitHub issue: https://github.com/showdownjs/showdown/issues/937
export function markdownToHTML(markdown) {
  // convert superscripts in the form "^(some text)" or "^text" to <sup>text</sup>
  const multiwordSuperscriptRegex = /\^\((.+?)\)/gm
  while (multiwordSuperscriptRegex.test(markdown)) {
    markdown = markdown.replace(multiwordSuperscriptRegex, '<sup>$1</sup>')
  }
  const superscriptRegex = /\^(\S+)/gm
  while (superscriptRegex.test(markdown)) {
    markdown = markdown.replace(superscriptRegex, '<sup>$1</sup>')
  }

  // add spaces after '>' to keep blockquotes (if it has '>!' ignore since that is spoilertext)
  markdown = markdown.replace(
    /^((?:&gt;|>)+)(?=[^!\s])/gm,
    function (match, p1) {
      return p1.replace(/&gt;/g, '>') + ' '
    }
  )

  // convert Reddit spoilertext
  const spoilerRegex = />!(.*)!</gm
  while (spoilerRegex.test(markdown)) {
    markdown = markdown.replace(spoilerRegex, '<mark>$1</mark>')
  }

  // convert markdown to HTML
  return showdownConverter.makeHtml(markdown)
}
